<template>
	<div class="safety-permit-maintenance">
		<div class="safety-permit-container">
			<div class="safety-permit-content">
				<!-- 左侧人员类型导航 -->
				<div class="personnel-type-nav">
					<div
						v-for="(item, index) in personnelTypes"
						:key="index"
						class="personnel-type-item"
						:class="{ active: activeTypeIndex === index }"
						@click="handleChangeType(index)"
					>
						{{ item.name }}
					</div>
				</div>

				<!-- 右侧内容区域 -->
				<div class="personnel-content">
					<!-- 根据选中的类型显示对应的内容 -->
					<div v-for="(item, index) in personnelTypes" v-show="activeTypeIndex === index" :key="index" class="personnel-section">
						<div class="section-header">
							<h4>{{ item.name }}</h4>
							<el-button v-if="isSetting && item.type == 'registeredPersonnel'" type="primary" @click="handleAddPersonnel">
								添加
							</el-button>
							<!-- 注册人员添加 -->
							<el-button
								v-if="isSetting && item.type !== 'overallData' && item.type !== 'registeredPersonnel'"
								type="primary"
								@click="handleOpenDialog(item.type, item.name)"
							>
								添加
							</el-button>
						</div>

						<!-- 搜索 -->
						<div class="search-container">
							<!-- <div class="search-form">
								<div class="form-item">
									<span class="label">姓名：</span>
									<el-input v-model="queryParams.name" placeholder="请输入姓名" clearable></el-input>
								</div>
								<div class="form-item">
									<span class="label">身份证号：</span>
									<el-input v-model="queryParams.sfzh" placeholder="请输入身份证号" clearable></el-input>
								</div>
								<div class="form-buttons">
									<el-button type="primary" @click="handleSearch(item.type, item.typeCode)">查询</el-button>
									<el-button @click="handleResetSearch(item.type, item.typeCode)">重置</el-button>
								</div>
							</div> -->
						</div>
						<template v-if="item.typeCode == '1'">
							<div class="form-content">
								<!-- 展示表单信息 -->
								<el-form ref="overallDataForm" :model="overallDataForm" :rules="rules" label-width="180px" :disabled="!isSetting">
									<div class="form-row">
										<el-form-item label="厂房情况：" prop="plantCondition" class="form-item">
											<el-checkbox-group v-model="overallDataForm.plantCondition" @change="handlePlantConditionChange">
												<el-checkbox label="自有"></el-checkbox>
												<el-checkbox label="租赁"></el-checkbox>
											</el-checkbox-group>
										</el-form-item>
										<el-form-item label="技术装备：" prop="technicalEquipment" class="form-item">
											<el-radio-group v-model="overallDataForm.technicalEquipment">
												<el-radio label="具备"></el-radio>
												<el-radio label="不具备"></el-radio>
											</el-radio-group>
										</el-form-item>
									</div>
									<div class="form-row">
										<el-form-item
											label="自有厂房面积："
											prop="privatelyOwnedPlantArea"
											class="form-item"
											v-if="showPrivatelyOwnedPlantArea"
										>
											<el-input v-model.trim="overallDataForm.privatelyOwnedPlantArea" placeholder="" v-positiveNumber>
												<template slot="append">万平方米</template>
											</el-input>
										</el-form-item>
										<el-form-item label="租赁厂房面积：" prop="loanDuePlantArea" class="form-item" v-if="showRentDate">
											<el-input v-model.trim="overallDataForm.loanDuePlantArea" placeholder="" v-positiveNumber>
												<template slot="append">万平方米</template>
											</el-input>
										</el-form-item>
									</div>
									<div class="form-row">
										<el-form-item label="租赁合同到期日期：" prop="loanDueDate" class="form-item loanDueDate" v-if="showRentDate">
											<el-date-picker
												v-model="overallDataForm.loanDueDate"
												type="date"
												placeholder="选择日期"
												format="yyyy-MM-dd"
												value-format="yyyy-MM-dd"
												style="width: 100%;"
											></el-date-picker>
										</el-form-item>
									</div>
									<div class="form-row" v-if="showNetAssets && isDiagnostic">
										<el-form-item label="净资产：" prop="netAsset" class="form-item">
											<el-input v-model.trim="overallDataForm.netAsset" placeholder="" v-positiveNumber>
												<template slot="append">万元</template>
											</el-input>
										</el-form-item>
									</div>
								</el-form>
							</div>
						</template>
						<!-- 综合材料不展示表格数据 -->
						<template v-else>
							<!-- 数据表格 -->
							<data-table
								:table-data="personnelData[item.type] || []"
								:column="personnelColumns[item.type]"
								:loading="loadingStatus[item.type]"
								:page-options="pageOptions[item.type]"
								:border="true"
								:selection="false"
								:index="true"
								@page-change="pager => handlePageChange(pager, item.type, item.typeCode)"
							>
								<!-- 职称人员，职称信息 -->
								<template v-if="item.type === 'professionalPersonnel'" slot="slot_certificateName" slot-scope="{ scope }">
									{{ scope.row.certificateName }}-{{ scope.row.certificateSubName }}
								</template>
								<!-- 技术负责人表格、负责资质类别 -->
								<template v-if="item.type === 'jsfzr'" slot="slot_zzCode" slot-scope="{ scope }">
									{{ formatZzCode(scope.row.zzCode) }}
								</template>
								<!-- 操作列 -->
								<template slot="slot_action" slot-scope="{ scope }">
									<el-button
										v-if="isSetting && item.type !== 'registeredPersonnel'"
										type="text"
										@click="handleEdit(scope.row, item.type, item.name)"
									>
										编辑
									</el-button>
									<el-button
										v-if="isSetting && item.type === 'enterpriseProjectPerformance'"
										type="text"
										@click="handleSeeDetail(scope.row, item.type, item.name)"
									>
										详情
									</el-button>
									<!-- 技术负责人工程业绩-->
									<el-button v-if="item.type === 'jsfzr'" type="text" @click="handleAddJsfzrGcyj(scope.row)">
										工程业绩
									</el-button>
									<el-button
										v-if="isSetting"
										type="text"
										@click="handleDelete(scope.row, item.type, item.typeCode, scope.$index)"
									>
										删除
									</el-button>
								</template>
							</data-table>
						</template>
					</div>
					<div v-if="isSetting && activeTypeCode === '1' && !isDiagnostic" class="maintenance-footer">
						<el-button type="primary" @click="handleSaveOverallDataInfo">保 存</el-button>
					</div>
				</div>
			</div>

			<!-- 未绑定企业遮罩层 -->
			<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>
			<!-- 未开通会员提示 -->
			<nonbind-vip v-else-if="isNormalVip"></nonbind-vip>
		</div>

		<!-- 人员库 -->
		<jr-dialog :visible.sync="staffLibraryVisible" title="人员库" width="1400px" top="100px" :append-to-body="true">
			<template v-if="staffLibraryVisible" slot="content">
				<staff-library ref="staffLibrary" :is-setting="true"></staff-library>
			</template>
			<template slot="footer">
				<el-button @click="handleCloseStaff">取 消</el-button>
				<el-button type="primary" :loading="saveStaffLoading" @click="handleSaveStaffInfo">确 定</el-button>
			</template>
		</jr-dialog>

		<!-- 职称、技工、技术装备、企业工程业绩、技术负责人表单-start -->
		<jr-dialog :visible.sync="visible" :title="title" width="1400px" top="100px" :append-to-body="true" :showBtn="!isEdit">
			<template slot="content" v-if="visible">
				<!-- 列表数据表单添加动态组件 -->
				<component
					ref="dialogComponent"
					:is="currentDialogComponent"
					:isEdit="isEdit"
					:qualificationInfo="qualificationInfo"
				></component>
			</template>
			<template slot="footer" v-if="!isEdit">
				<el-button @click="visible = false">取 消</el-button>
				<el-button type="primary" :loading="visibleLoading" @click="handleSaveForm">确 定</el-button>
			</template>
		</jr-dialog>

		<!-- 技术负责人工程业绩表格-start -->
		<jr-dialog
			:visible.sync="jsfzrGcyjVisible"
			title="技术负责人工程业绩"
			width="1400px"
			top="100px"
			:append-to-body="true"
			:showBtn="false"
		>
			<template slot="content" v-if="jsfzrGcyjVisible">
				<!-- 列表数据表单添加动态组件 -->
				<jsfzr-gcyj :jsfzrId="jsfzrId" :isEdit="isEdit" :isSetting="isSetting" @changeIsEdit="changeIsEdit"></jsfzr-gcyj>
			</template>
			<template slot="footer" v-if="false">
				<el-button @click="jsfzrGcyjVisible = false">取 消</el-button>
				<el-button type="primary" @click="jsfzrGcyjVisible = false">确 定</el-button>
			</template>
		</jr-dialog>
		<!-- 技术负责人工程业绩表单-end -->
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import DataTable from '@/components/JrTable/DataTable'
	import NonbindVip from '@/components/NonBind/nonbindVip'
	import NonbindEnterprise from '@/components/NonBind/nonbindEnterprise'
	import StaffLibrary from '../components/jzyStaffLibrary.vue'
	import { mapGetters } from 'vuex'
	import {
		saveOrUpdateJzyhSelfRegisterPerson,
		queryJzyhMaterialRecord,
		saveJzyhMaterialRecord,
		queryJzyhSelfRegisterPersonHas,
		saveOrUpdateJzyhEquipment,
		queryJzyhEquipment,
		removeJzyhSelfRegisterPerson,
		removeJzyhEquipment,
		queryJzyhProjectPerformance,
		saveOrUpdateJzyhProjectPerformance,
		removeJzyhProjectPerformance
	} from '@/api/certTreasure/materialRecord'
	import { transObject, deepClone, arrayJoin, splitArray } from '@/utils/index'
	// 职称人员组件
	import ProfessionalPersonnel from '../components/professionalPersonnel.vue'
	// 技工人员组件
	import Technician from '../components/technician.vue'
	// 技术装备组件
	import TechnicalEquipment from '../components/technicalEquipment.vue'
	//工程业绩组件
	import EnterpriseProjectPerformance from '../components/enterpriseProjectPerformance.vue'
	// 技术负责人组件
	import Jsfzr from '../components/jsfzr.vue'
	import { queryCommonDictionary } from '@/api/dictionary/index'
	import JsfzrGcyj from '../components/JsfzrGcyj.vue'
	// 建筑业企业资质-资质材料维护
	export default {
		name: 'ConstructionEnterpriseMaintenance',
		components: {
			JrDialog,
			DataTable,
			NonbindVip,
			NonbindEnterprise,
			StaffLibrary,
			ProfessionalPersonnel,
			Technician,
			TechnicalEquipment,
			EnterpriseProjectPerformance,
			Jsfzr,
			JsfzrGcyj
		},
		props: {
			// 是否开启配置
			isSetting: {
				type: Boolean,
				default: false
			},
			// 是否是诊断提交材料处打开，主要用于控制“保存“是否显示
			isDiagnostic: {
				type: Boolean,
				default: false
			},
			// 建筑业企业资质选择的资质项信息
			qualificationInfo: {
				type: Array,
				default: () => []
			},
			// 是否展示净资产
			showNetAssets: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				// 诊断记录id
				diagnosisRecordId: '',
				// 人员类型列表-自维护
				zwhPersonnelTypes: [
					{ name: '综合材料', type: 'overallData', typeCode: '1' },
					{ name: '注册人员', type: 'registeredPersonnel', typeCode: '3' },
					{ name: '职称人员', type: 'professionalPersonnel', typeCode: '4' },
					{ name: '技工人员', type: 'technician', typeCode: '5' },
					{ name: '技术装备', type: 'technicalEquipment', typeCode: '6' },
					{ name: '企业工程业绩', type: 'enterpriseProjectPerformance', typeCode: '7' }
				],
				// 点击立即诊断-人员类型列表
				diagnosticPersonnelTypes: [
					{ name: '综合材料', type: 'overallData', typeCode: '1' },
					{ name: '注册人员', type: 'registeredPersonnel', typeCode: '3' },
					{ name: '职称人员', type: 'professionalPersonnel', typeCode: '4' },
					{ name: '技工人员', type: 'technician', typeCode: '5' },
					{ name: '技术装备', type: 'technicalEquipment', typeCode: '6' },
					{ name: '企业工程业绩', type: 'enterpriseProjectPerformance', typeCode: '7' },
					{ name: '技术负责人', type: 'jsfzr', typeCode: '8' }
				],
				// 人员配置搜索
				queryParams: {
					name: '',
					sfzh: ''
				},
				// 当前选中的人员类型索引
				activeTypeIndex: 0,
				// 当前人员类型编码
				activeTypeCode: '',
				// 表格加载状态（每种类型单独控制）
				loadingStatus: {
					registeredPersonnel: false,
					professionalPersonnel: false,
					technician: false,
					technicalEquipment: false,
					enterpriseProjectPerformance: false,
					jsfzr: false
				},
				// 表格列配置
				personnelColumns: {
					// 注册人员表格列配置
					registeredPersonnel: [
						{ prop: 'personName', label: '姓名', minWidth: '100' },
						{ prop: 'certificateName', label: '证书类型', minWidth: '120' },
						{ prop: 'registerProject', label: '注册专业', minWidth: '180' },
						{ prop: 'idCard', label: '身份证号', minWidth: '120' },
						{ prop: '', label: '发证单位', minWidth: '120' },
						{ prop: 'certificateCode', label: '证书编号', minWidth: '120' },
						{ prop: 'validityTime', label: '证书有效期', minWidth: '120' }
					],
					// 职称人员表格列配置
					professionalPersonnel: [
						{ prop: 'personName', label: '姓名', minWidth: '100' },
						{ prop: 'idCard', label: '身份证号', minWidth: '120' },
						{ prop: 'certificateName', label: '职称', minWidth: '120', slot: 'slot_certificateName' },
						{ prop: 'professionalProject', label: '职称专业', minWidth: '120' },
						{ prop: 'professionalLevel', label: '职称等级', minWidth: '120' },
						{ prop: 'zzName', label: '申报资质类别', minWidth: '120' }
					],
					// 技工人员表格列配置
					technician: [
						{ prop: 'personName', label: '姓名', minWidth: '100' },
						{ prop: 'idCard', label: '身份证号', minWidth: '120' },
						{ prop: 'professionalLevel', label: '等级', minWidth: '120' },
						{ prop: 'professionalProject', label: '专业', minWidth: '120' }
					],
					// 技术装备表格列配置
					technicalEquipment: [
						{ prop: 'equipmentName', label: '设备仪器及名称', minWidth: '100' },
						{ prop: 'model', label: '型号', minWidth: '120' },
						{ prop: 'origin', label: '产地', minWidth: '120' },
						{ prop: 'manufactureDate', label: '出厂日期', minWidth: '120' },
						{ prop: 'quantity', label: '数量（台）', minWidth: '120' },
						{ prop: 'powerKw', label: '功率（千瓦）', minWidth: '120' },
						{ prop: 'originalValue', label: '原值（万元）', minWidth: '120' },
						{ prop: 'netValue', label: '净值', minWidth: '120' }
					],
					// 企业工程业绩表格列配置
					enterpriseProjectPerformance: [
						{ prop: 'gcmc', label: '工程名称', minWidth: '100' },
						{ prop: 'htbh', label: '合同编号', minWidth: '120' },
						{ prop: 'xmbm', label: '项目编号', minWidth: '180' },
						{ prop: 'jszb', label: '技术指标', minWidth: '120' }
					],
					// 技术负责人
					jsfzr: [
						{ prop: 'zzCode', label: '负责资质类别', minWidth: '120', slot: 'slot_zzCode' },
						{ prop: 'personName', label: '姓名', minWidth: '100' },
						{ prop: 'idCard', label: '身份证号', minWidth: '120' },
						{ prop: 'managementYear', label: '工程管理年限', minWidth: '180' },
						{ prop: 'professionalProject', label: '职称专业', minWidth: '120' },
						{ prop: 'professionalLevel', label: '职称等级', minWidth: '120' },
						{ prop: 'certificateCode', label: '注册证书编号', minWidth: '120' },
						{ prop: 'certificateName', label: '注册等级', minWidth: '120' },
						{ prop: 'registerProject', label: '注册专业', minWidth: '120' }
					]
				},
				// 分页配置（每种类型单独控制）
				pageOptions: {
					registeredPersonnel: { page: 1, limit: 10, total: 0 },
					professionalPersonnel: { page: 1, limit: 10, total: 0 },
					technician: { page: 1, limit: 10, total: 0 },
					technicalEquipment: { page: 1, limit: 10, total: 0 },
					enterpriseProjectPerformance: { page: 1, limit: 10, total: 0 },
					jsfzr: { page: 1, limit: 10, total: 0 }
				},
				// 各类型人员数据
				personnelData: {
					// 注册人员
					registeredPersonnel: [],
					// 职称人员
					professionalPersonnel: [],
					// 技工人员
					technician: [],
					// 技术装备
					technicalEquipment: [],
					// 企业工程业绩
					enterpriseProjectPerformance: [],
					// 技术负责人
					jsfzr: []
				},
				// 人员库弹窗
				staffLibraryVisible: false,
				// 人员库人员选择保存loading
				saveStaffLoading: false,
				// 其余表单弹窗选择保存loading
				visibleLoading: false,
				// 综合材料表单数据
				overallDataForm: {
					// 厂房情况（自有、租赁）单选框
					plantCondition: [],
					// 租赁合同到期日期（年月日）
					loanDueDate: '',
					// 技术装备（具备、不具备）单选框
					technicalEquipment: '',
					// 厂房面积
					plantArea: '',
					// 自有厂房面积
					privatelyOwnedPlantArea: '',
					// 租赁厂房面积
					loanDuePlantArea: '',
					// 净资产
					netAsset: '',
					// 主键id
					id: ''
				},
				rules: {
					plantCondition: [{ required: true, message: '请选择厂房情况', trigger: 'blur' }],
					loanDueDate: [{ required: true, message: '请选择租赁合同到期日期', trigger: 'blur' }],
					technicalEquipment: [{ required: true, message: '请选择技术装备', trigger: 'blur' }],
					privatelyOwnedPlantArea: [{ required: true, message: '请输入自有厂房面积', trigger: 'blur' }],
					loanDuePlantArea: [{ required: true, message: '请输入租赁厂房面积', trigger: 'blur' }],
					netAsset: [{ required: true, message: '请输入净资产', trigger: 'blur' }]
				},
				// 当前表单组件名称
				currentDialogComponent: '',
				title: '',
				visible: false,
				// 查看详情是否能操作
				isEdit: false,
				// 建筑业资质类别字典
				qualificationCollection: [],
				// 技术负责人工程业绩弹窗
				jsfzrGcyjVisible: false,
				// 技术负责人id
				jsfzrId: ''
			}
		},
		computed: {
			...mapGetters(['isHasCompany', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			// 是否展示租赁合同到期日期
			showRentDate() {
				return this.overallDataForm.plantCondition.includes('租赁')
			},
			// 是否展示自有厂房面积
			showPrivatelyOwnedPlantArea() {
				return this.overallDataForm.plantCondition.includes('自有')
			},
			// isDiagnostic为true，那么personnelTypes值会变化
			personnelTypes() {
				// if (this.isDiagnostic || this.diagnosisRecordId) {
				// 	return this.diagnosticPersonnelTypes
				// }
				// return this.zwhPersonnelTypes
				return this.diagnosticPersonnelTypes
			}
		},
		watch: {
			isSetting: {
				handler: function(val) {
					if (val) {
						// 循环为 personnelColumns 每一项添加操作列
						for (const key in this.personnelColumns) {
							this.personnelColumns[key].push({
								slot: 'slot_action',
								label: '操作',
								minWidth: '120',
								fixed: 'right'
							})
						}
					} else {
						this.personnelColumns['jsfzr'].push({
							slot: 'slot_action',
							label: '操作',
							minWidth: '120',
							fixed: 'right'
						})
					}
				},
				immediate: true
			},
			// 监听选择的资质类型
			qualificationInfo(newVal) {
				if (newVal) {
					let zzCodeArr = newVal[0].collection.map(item => item.dictcode)
					this.personnelData.jsfzr = this.personnelData.jsfzr.filter(item => {
						return zzCodeArr.includes(item.zzCode)
					})
				}
			}
		},
		created() {
			// 获取建筑业申报资质类别数据
			this.handleInitDictionary()
		},
		mounted() {
			// 获取诊断记录对应的记录id
			this.diagnosisRecordId = this.$route.query && this.$route.query.recordId
			this.activeTypeCode = this.personnelTypes[this.activeTypeIndex].typeCode
			// 已绑定企业，并且成为了vip或者svip
			if (this.isHasCompany && (this.isVip || this.isSVip)) {
				// 获取综合材料信息接口
				this.handleQueryOverallData()
				// 获取各人员信息
				this.fetchPersonnelData('registeredPersonnel')
				this.fetchPersonnelData('professionalPersonnel')
				this.fetchPersonnelData('technician')
				this.fetchPersonnelData('technicalEquipment')
				this.fetchPersonnelData('enterpriseProjectPerformance')
			}
		},
		methods: {
			// 获取建筑业申报资质类别数据
			handleInitDictionary() {
				// 申报资质类别字典
				const params = {
					// 资质等级
					dictionaryId: '1',
					// 查询全部资质
					cxType: '2'
				}
				queryCommonDictionary(params)
					.then(response => {
						const { data } = response

						if (data && data.length) {
							// 遍历数据给每一个子项添加selected属性
							data.forEach(item => {
								if (item.collection && Array.isArray(item.collection)) {
									item.collection.forEach(subItem => {
										subItem.selected = false
									})
								}
							})
							// zzCodeList为对象数组，现在要取出其中一项的code为107的
							this.qualificationCollection = data.filter(item => item.code === '107')[0].collection
						}
					})
					.catch(error => {
						this.qualificationCollection = []
					})
			},

			// 切换厂房情况
			handlePlantConditionChange(val) {
				if (!val.includes('自有')) {
					this.overallDataForm.privatelyOwnedPlantArea = ''
				}
				if (!val.includes('租赁')) {
					this.overallDataForm.loanDueDate = ''
					this.overallDataForm.loanDuePlantArea = ''
				}
			},
			// 获取综合材料信息
			handleQueryOverallData() {
				let params = {
					diagnosisRecordId: this.diagnosisRecordId ? this.diagnosisRecordId : '001'
				}
				queryJzyhMaterialRecord(params).then(res => {
					const { data } = res

					if (data) {
						// 将目标数据转为我指定的属性对象
						transObject(data, this.overallDataForm)
						splitArray(this.overallDataForm, 'plantCondition')
					} else {
						this.overallDataForm = {
							// 厂房情况（自有、租赁）单选框
							plantCondition: [],
							// 租赁合同到期日期（年月日）
							loanDueDate: '',
							// 技术装备（具备、不具备）单选框
							technicalEquipment: '',
							// 厂房面积
							plantArea: '',
							// 自有厂房面积
							privatelyOwnedPlantArea: '',
							// 租赁厂房面积
							loanDuePlantArea: '',
							// 净资产
							netAsset: '',
							// 主键id
							id: ''
						}
					}
				})
			},

			// 保存综合材料
			handleSaveOverallDataInfo() {
				this.$refs.overallDataForm[0].validate(valid => {
					if (valid) {
						let params = deepClone(this.overallDataForm)
						arrayJoin(params, 'plantCondition')
						// 调用保存接口
						saveJzyhMaterialRecord(params).then(res => {
							this.$modal.msgSuccess('保存成功')
							this.handleQueryOverallData()
						})
					} else {
						console.log('表单验证失败')
						return false
					}
				})
			},

			// 切换人员类型
			handleChangeType(index) {
				this.activeTypeIndex = index
				const activeTypeCode = this.personnelTypes[index].typeCode
				const activeType = this.personnelTypes[index].type
				this.activeTypeCode = activeTypeCode

				// 在提交资质诊断界面中，切换左侧，调取保存综合材料信息
				if (this.isDiagnostic) {
					let params = deepClone(this.overallDataForm)
					arrayJoin(params, 'plantCondition')
					// 调用保存接口
					saveJzyhMaterialRecord(params).then(res => {
						// 获取材料维护信息
						this.fetchPersonnelData(activeType, activeTypeCode)
					})
				} else {
					// 获取材料维护信息
					this.fetchPersonnelData(activeType, activeTypeCode)
				}
			},

			// 分页变化
			handlePageChange(pager, type, rylx) {
				this.pageOptions[type].page = pager.page
				this.pageOptions[type].limit = pager.limit
				this.fetchPersonnelData(type)
			},

			// 搜索
			handleSearch(type, rylx) {
				this.pageOptions[type].page = 1
				this.pageOptions[type].limit = 10
				this.fetchPersonnelData(type)
			},

			// 重置搜索
			handleResetSearch(type, rylx) {
				this.queryParams = {
					name: '',
					sfzh: ''
				}
				this.fetchPersonnelData(type)
			},

			// 打开企业人员库选择人员
			handleAddPersonnel() {
				this.staffLibraryVisible = true
			},

			// 打开弹窗选择器
			handleOpenDialog(type, name) {
				this.isEdit = false
				this.currentDialogComponent = type
				this.visible = true
				this.title = '添加' + name
			},

			// 保存建筑业资质材料人员维护信息
			handleSaveStaffInfo() {
				const selectPersons = this.$refs.staffLibrary.staffIdArray
				if (selectPersons.length === 0) {
					this.$modal.msgWarning('请选择人员')
					return
				}
				const data = {
					personType: '注册人员',
					idList: null
				}
				// 插入人员时，指定插入类型
				data.idList = selectPersons.map(item => item.id).join(',')
				this.saveStaffLoading = true
				saveOrUpdateJzyhSelfRegisterPerson(data)
					.then(response => {
						this.$modal.msgSuccess('保存成功')
						this.fetchPersonnelData('registeredPersonnel')
						this.saveStaffLoading = false
						this.staffLibraryVisible = false
					})
					.catch(error => {
						this.saveStaffLoading = false
					})
			},

			// 关闭材料维护
			handleCloseStaff() {
				this.staffLibraryVisible = false
			},

			// 删除操作
			handleDelete(row, type, typeCode, index) {
				if (type === 'registeredPersonnel' || type === 'professionalPersonnel' || type === 'technician' || type === 'jsfzr') {
					this.handleDeletePerson(row, type)
				} else if (type === 'technicalEquipment') {
					this.handleDeleteTechnicalEquipment(row, type)
				} else if (type === 'enterpriseProjectPerformance') {
					this.handleDeleteEnterpriseProjectPerformance(row, type)
				}
				// else if (type === 'jsfzr') {
				// 	this.personnelData.jsfzr.splice(index, 1)
				// 	// 删除操作更新一下数据列表的序号
				// 	this.personnelData.jsfzr.forEach((item, index) => {
				// 		item.safeNum = index + 1
				// 	})
				// }
			},

			// 工程业绩操作
			handleAddJsfzrGcyj(row) {
				this.isEdit = true
				this.jsfzrGcyjVisible = true
				this.jsfzrId = row.id
			},

			// 人员删除操作
			handleDeletePerson(row, type) {
				const data = {
					ids: row.id,
					personType:
						type === 'registeredPersonnel'
							? '注册人员'
							: type === 'professionalPersonnel'
							? '职称人员'
							: type === 'technician'
							? '技工人员'
							: '技术负责人'
				}

				this.$modal
					.confirm('请确认是否删除该人员信息？')
					.then(() => {
						return removeJzyhSelfRegisterPerson(data)
					})
					.then(() => {
						this.$modal.msgSuccess('操作成功')
						this.fetchPersonnelData(type)
					})
					.catch(() => {})
			},

			// 技术装备删除操作
			handleDeleteTechnicalEquipment(row, type) {
				const data = {
					ids: row.id
				}
				this.$modal
					.confirm('请确认是否删除该技术装备信息？')
					.then(() => {
						return removeJzyhEquipment(data)
					})
					.then(() => {
						this.$modal.msgSuccess('操作成功')
						this.fetchPersonnelData(type)
					})
					.catch(() => {})
			},

			// 企业工程业绩删除操作
			handleDeleteEnterpriseProjectPerformance(row, type) {
				const data = {
					ids: row.id
				}
				this.$modal
					.confirm('请确认是否删除该工程业绩信息？')
					.then(() => {
						return removeJzyhProjectPerformance(data)
					})
					.then(() => {
						this.$modal.msgSuccess('操作成功')
						this.fetchPersonnelData(type)
					})
					.catch(() => {})
			},

			// 编辑操作
			handleEdit(row, type, name) {
				let rowData = { ...row }
				// 企业工程业绩
				if (type === 'enterpriseProjectPerformance') {
					rowData.gccbfs = rowData.gccbfs.split(',')
					rowData.sgzzfs = rowData.sgzzfs.split(',')
				}
				// 职称人员
				if (type === 'professionalPersonnel') {
					splitArray(rowData, 'professionalProject')
					splitArray(rowData, 'zzCode')
					rowData.certificateName = [rowData.certificateName, rowData.certificateSubName]
				}

				// 技工人员
				if (type === 'technician') {
					splitArray(rowData, 'professionalProject')
				}

				// 技术负责人
				if (type === 'jsfzr') {
					splitArray(rowData, 'professionalProject')
					if (rowData.certificateType == '注册证书') {
						splitArray(rowData, 'registerProject')
					}
				}

				this.currentDialogComponent = type
				this.visible = true
				this.title = '编辑' + name
				this.isEdit = false
				this.$nextTick(() => {
					this.$refs.dialogComponent.form = JSON.parse(JSON.stringify(rowData))
				})
			},

			//	查看详情接口
			handleSeeDetail(row, type, name) {
				let rowData = { ...row }
				// 企业工程业绩
				if (type === 'enterpriseProjectPerformance') {
					rowData.gccbfs = rowData.gccbfs.split(',')
					rowData.sgzzfs = rowData.sgzzfs.split(',')
				}
				this.currentDialogComponent = type
				this.visible = true
				this.title = '查看' + name
				this.isEdit = true
				this.$nextTick(() => {
					this.$refs.dialogComponent.form = JSON.parse(JSON.stringify(rowData))
				})
			},

			// 职称、技工、技术装备、企业工程业绩保存操作
			handleSaveForm() {
				this.$refs.dialogComponent.handleSaveInfo().then(res => {
					// let formId = res.id
					// let formIndex = ''
					switch (this.currentDialogComponent) {
						// 职称人员
						case 'professionalPersonnel':
							// 调取增加修改职称人员接口
							this.handelAddPersonnelInfo(res, 'professionalPersonnel')
							break
						// 技工人员
						case 'technician':
							this.handelAddPersonnelInfo(res, 'technician')
							break
						// 技术装备
						case 'technicalEquipment':
							this.handelAddTechnicalEquipment(res)
							break
						// 企业工程业绩
						case 'enterpriseProjectPerformance':
							this.handelAddEnterpriseProjectPerformance(res)
							break
						// 技术负责人
						case 'jsfzr':
							// // 找出当前数据在集合中的位置
							// formIndex = this.personnelData.jsfzr.findIndex(item => {
							// 	return item.id === formId
							// })

							// let deepRes = deepClone(res)
							// arrayJoin(deepRes, 'professionalProject')
							// arrayJoin(deepRes, 'registerProject')
							// if (formIndex > -1) {
							// 	// 编辑操作
							// 	this.personnelData.jsfzr.splice(formIndex, 1, deepRes)
							// } else {
							// 	// 新增操作，保存时为每一条数据增加一个序号safeNum
							// 	const newRes = { ...deepRes, safeNum: this.personnelData.jsfzr.length + 1 }
							// 	this.personnelData.jsfzr.push(newRes)
							// }
							// // 关闭弹窗
							// this.visible = false
							this.handelAddPersonnelInfo(res, 'jsfzr')
							break
					}
				})
			},

			// 新增修改职称、技工人员接口信息
			handelAddPersonnelInfo(formData, type) {
				this.visibleLoading = true

				let deepFormData = deepClone(formData)

				// 职称人员，传参需要处理，将需要处理的数组转为字符串给后端
				if (type === 'professionalPersonnel') {
					arrayJoin(deepFormData, 'professionalProject')
					arrayJoin(deepFormData, 'zzCode')
					deepFormData.certificateSubName = deepFormData.certificateName[1]
					deepFormData.certificateName = deepFormData.certificateName[0]
				}

				// 技工人员，传参需要处理，将需要处理的数组转为字符串给后端
				if (type === 'technician') {
					arrayJoin(deepFormData, 'professionalProject')
				}

				// 技术负责人，传参需要处理，将需要处理的数组转为字符串给后端
				if (type === 'jsfzr') {
					arrayJoin(deepFormData, 'professionalProject')
					arrayJoin(deepFormData, 'registerProject')
				}

				const data = {
					personType: type === 'professionalPersonnel' ? '职称人员' : type === 'technician' ? '技工人员' : '技术负责人',
					...deepFormData
				}
				saveOrUpdateJzyhSelfRegisterPerson(data)
					.then(response => {
						this.$modal.msgSuccess('保存成功')
						this.fetchPersonnelData(type)
						this.visibleLoading = false
						this.visible = false
					})
					.catch(error => {
						this.visibleLoading = false
						this.visible = false
					})
			},

			// 新增修改技术装备接口信息
			handelAddTechnicalEquipment(formData) {
				this.visibleLoading = true

				saveOrUpdateJzyhEquipment(formData)
					.then(response => {
						this.$modal.msgSuccess('保存成功')
						this.fetchPersonnelData('technicalEquipment')
						this.visibleLoading = false
						this.visible = false
					})
					.catch(error => {
						this.visibleLoading = false
						this.visible = false
					})
			},

			// 新增修改企业工程业绩接口信息
			handelAddEnterpriseProjectPerformance(formData) {
				// 处理formData相关数据
				let data = { ...formData }

				data.gccbfs = data.gccbfs.join(',')
				data.sgzzfs = data.sgzzfs.join(',')

				this.visibleLoading = true

				saveOrUpdateJzyhProjectPerformance(data)
					.then(response => {
						this.$modal.msgSuccess('保存成功')
						this.fetchPersonnelData('enterpriseProjectPerformance')
						this.visibleLoading = false
						this.visible = false
					})
					.catch(error => {
						this.visibleLoading = false
						this.visible = false
					})
			},

			// 统一调取数据接口方法，根据左侧菜单分别调取不同的查询接口
			fetchPersonnelData(type) {
				if (type === 'overallData') {
					this.handleQueryOverallData()
				} else if (
					type === 'registeredPersonnel' ||
					type === 'professionalPersonnel' ||
					type === 'technician' ||
					type === 'jsfzr'
				) {
					this.handleQueryPersonnelData(type)
				} else if (type === 'technicalEquipment') {
					this.handleQueryTechnicalEquipmentData(type)
				} else if (type === 'enterpriseProjectPerformance') {
					this.handleQueryEnterpriseProjectPerformanceData(type)
				}
			},

			// 查询注册、职称、技工人员数据
			handleQueryPersonnelData(type) {
				this.loadingStatus[type] = true

				const params = {
					diagnosisRecordId: this.diagnosisRecordId ? this.diagnosisRecordId : '001',
					page: type === 'jsfzr' ? 1 : this.pageOptions[type].page,
					size: type === 'jsfzr' ? 200 : this.pageOptions[type].limit,
					personType:
						type === 'registeredPersonnel'
							? '注册人员'
							: type === 'professionalPersonnel'
							? '职称人员'
							: type === 'technician'
							? '技工人员'
							: type === 'jsfzr'
							? '技术负责人'
							: ''
				}

				queryJzyhSelfRegisterPersonHas(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.personnelData[type] = data.records

							// if (type != 'jsfzr') {
							this.pageOptions[type].total = data.total
							// }
						} else {
							this.personnelData[type] = []
							// if (type != 'jsfzr') {
							this.pageOptions[type].total = data.total
							// }
						}
						this.loadingStatus[type] = false
					})
					.catch(error => {
						this.personnelData[type] = []
						this.pageOptions[type].total = 0
						this.loadingStatus[type] = false
					})
			},

			// 查询技术装备数据
			handleQueryTechnicalEquipmentData(type) {
				this.loadingStatus[type] = true

				const params = {
					page: this.pageOptions[type].page,
					size: this.pageOptions[type].limit,
					diagnosisRecordId: this.diagnosisRecordId ? this.diagnosisRecordId : '001'
				}

				queryJzyhEquipment(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.personnelData[type] = data.records
							this.pageOptions[type].total = data.total
						} else {
							this.personnelData[type] = []
							this.pageOptions[type].total = 0
						}
						this.loadingStatus[type] = false
					})
					.catch(error => {
						this.personnelData[type] = []
						this.pageOptions[type].total = 0
						this.loadingStatus[type] = false
					})
			},

			// 查询企业工程业绩数据
			handleQueryEnterpriseProjectPerformanceData(type) {
				this.loadingStatus[type] = true

				const params = {
					page: this.pageOptions[type].page,
					size: this.pageOptions[type].limit,
					diagnosisRecordId: this.diagnosisRecordId ? this.diagnosisRecordId : '001'
				}

				queryJzyhProjectPerformance(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.personnelData[type] = data.records
							this.pageOptions[type].total = data.total
						} else {
							this.personnelData[type] = []
							this.pageOptions[type].total = 0
						}
						this.loadingStatus[type] = false
					})
					.catch(error => {
						this.personnelData[type] = []
						this.pageOptions[type].total = 0
						this.loadingStatus[type] = false
					})
			},
			// 验证资质诊断材料是否维护
			handleValidMaintenanceInfoIsSetting() {
				let listFlag = true
				this.$refs.overallDataForm[0].validate(valid => {
					if (!valid) {
						listFlag = false
					} else {
						listFlag = true
						// 定义需要验证的人员类型
						const requiredTypes = [
							'registeredPersonnel', // 注册人员
							'professionalPersonnel', // 职称人员
							'technician', // 技工人员
							'technicalEquipment', // 技术装备
							'enterpriseProjectPerformance', // 企业工程业绩
							'jsfzr' // 技术负责人
						]
						console.log(this.personnelData)

						// 遍历需要验证的人员类型，检查是否有数据
						for (const type of requiredTypes) {
							const personnelList = this.personnelData[type] || []

							// 如果某类人员数据为空，弹出提示并返回false
							if (personnelList.length === 0) {
								// 找出某一项未维护类型
								listFlag = false
								break
							}
						}
					}
				})
				return listFlag
			},
			// 诊断材料提交处材料信息保存
			saveMaintenanceInfoPromise() {
				return new Promise((resolve, reject) => {
					this.$refs.overallDataForm.validate(valid => {
						if (valid) {
							let params = deepClone(this.overallDataForm)
							arrayJoin(params, 'plantCondition')
							// 调用保存接口
							saveJzyhMaterialRecord(params)
								.then(res => {
									resolve()
								})
								.catch(error => {
									reject()
								})
						} else {
							reject()
						}
					})
				})
			},
			// 处理负责资质类别名称
			formatZzCode(zzCode) {
				let newZzcode = this.qualificationCollection.filter(item => item.dictcode === zzCode)[0].dictionaryValues
				return newZzcode
			},
			// 传递给技术负责人-工程业绩组件方法
			changeIsEdit(value) {
				this.isEdit = value
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';
	.safety-permit-maintenance {
		.safety-permit-container {
			background-color: #fff;
			border-radius: 4px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			position: relative;

			.safety-permit-title {
				padding: 15px 20px;
				border-bottom: 1px solid #ebeef5;

				h3 {
					margin: 0;
					font-size: 18px;
					font-weight: 500;
					color: #333;
				}
			}

			.safety-permit-content {
				display: flex;
				min-height: 600px;

				.personnel-type-nav {
					width: 240px;
					border-right: 1px solid #ebeef5;

					.personnel-type-item {
						padding: 15px 20px;
						cursor: pointer;
						transition: all 0.3s;
						border-bottom: 1px solid #ebeef5;
						color: #606266;

						&:hover {
							background-color: #f5f7fa;
						}

						&.active {
							color: #236fca;
							background-color: #ecf5ff;
							border-left: 4px solid #236fca;
						}
					}
				}

				.personnel-content {
					flex: 1;
					padding: 20px;
					overflow-y: auto;

					.personnel-section {
						// margin-bottom: 30px;

						.section-header {
							display: flex;
							justify-content: space-between;
							align-items: center;
							margin-bottom: 15px;
							position: relative;

							h4 {
								margin: 0;
								font-size: 16px;
								font-weight: 500;
								color: #333;
							}
						}

						.search-container {
							padding: 10px;

							.search-form {
								display: flex;
								flex-wrap: wrap;
								gap: 20px;

								.form-item {
									display: flex;
									align-items: center;

									.label {
										white-space: nowrap;
										margin-right: 8px;
										color: #606266;
									}

									.el-input {
										width: 200px;
									}

									.el-select {
										width: 200px;
									}

									.el-date-picker {
										width: 400px;
									}
								}
							}
						}
					}

					.maintenance-footer {
						text-align: center;
						padding-top: 30px;

						.el-button--primary {
							width: 100px;
						}
					}
				}
			}
		}
	}

	.form-content {
		.form-row {
			display: flex;
		}
		.form-item {
			flex: 1;
			margin-bottom: 20px;
			::v-deep {
				.el-input {
					input {
						padding: 0 15px 0 15px;
					}
				}
			}
		}
		.loanDueDate {
			::v-deep {
				.el-input {
					input {
						padding: 0 15px 0 40px;
					}
				}
			}
		}
	}

	@keyframes slideInLeft {
		from {
			transform: translateX(-100%);
			opacity: 0;
		}
		to {
			transform: translateX(0);
			opacity: 1;
		}
	}

	@keyframes slideInRight {
		from {
			transform: translateX(100%);
			opacity: 0;
		}
		to {
			transform: translateX(0);
			opacity: 1;
		}
	}
</style>
